"use client";

import gsap from "gsap";
import { useLayoutEffect } from "react";

const Header = () => {
  useLayoutEffect(() => {
    const tl = gsap.timeline();
    tl.fromTo(".header", { y: 200 }, { y: 0 }, "-=0.3");
    tl.fromTo(
      ".header .container",
      { opacity: 0, translateY: 40 },
      { opacity: 1, translateY: 0 },
      "-=0"
    );

    return () => {
      tl.kill();
    };
  }, []);

  return (
    <div className="header header-digital valign">
      <div className="container ontop">
        <div className="row">
          <div className="col-lg-12">
            <div className="caption">
              <h1>Experience long-term</h1>
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <p>
                    AI-powered and cloud-driven solutions to transform your
                    business. Our experts deliver innovative, scalable, and
                    high-quality results that fuel growth and success.
                  </p>
                </div>
                <div className="col-lg-6 md-mb30 just">
                  <h1>quality</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
